import angular from "angular";
import panel from "../services";

function isUnique(panel){
    return (scope, element) => {

        panel.registerEvent('is-unique-error', (e) => {
            let el = $('.register-'+e.detail.item);
            el.siblings('div.error').html('');
            el.siblings('div.error').append('<div>'+e.detail.message+'</div>');
        });


        $(element).keyup( () => {
            let test = $(element).attr('test');
            let value = $(element).val();

            if (value.trim() === '') return;

            let errors = [];
            let data = {test: test, value:value};
            let e = $(element);

            e.siblings('div.error').html('');

            let exp = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            if (test === 'email' && exp.test(value) == false) {
                errors.push("Invalid email.");
            }

            if (errors.length !== 0) {
                for (let i in errors) {
                    e.siblings('div.error').append('<div>'+errors[i]+'</div>');
                }
                return;
            }

            panel.post('/v1/account/unique', data, function(response){
                if (panel.okay(response)) {
                    if (!response.is_unique) {
                        let error = test.replace('_',' ')+' is not available.';
                        errors.push(error);
                    }
                }

                if (errors.length !== 0) {
                    for (let i in errors) {
                        e.siblings('div.error').append('<div>'+errors[i]+'</div>');
                    }
                }
            });
        });
    }
}

export default angular.module('directives.isUnique', [panel]).directive('isUnique', isUnique).name;



// WEBPACK FOOTER //
// ./src/app/directives/isUnique.js